/**
 * P3-10 · FAQ panel — per-product Q&A as a definition list (question → answer).
 * Plain text off the projection; ordering is merchandising order.
 */
import type { PdpFaq } from "~/server/api/schemas/pdp";

export function Faq({ faqs }: { faqs: PdpFaq[] }) {
  return (
    <dl className="flex max-w-prose flex-col gap-5 text-sm">
      {faqs.map((f) => (
        <div key={f.id}>
          <dt className="font-semibold text-fg">{f.question}</dt>
          <dd className="mt-1 leading-relaxed text-fg-muted">{f.answer}</dd>
        </div>
      ))}
    </dl>
  );
}
